import { Button } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const SubmitButton = ({ disabled, handleSubmit, sx, buttonText = "Save" }) => {
  return (
    <Button
      sx={{
        background: HNSColors.secondary[500],
        "&:hover": {
          background: HNSColors.secondary[600],
        },
        ...sx,
      }}
      disabled={disabled}
      className="px-8 py-2 text-sm font-normal normal-case transition rounded-full"
      variant="contained"
      disableElevation
      type={handleSubmit ? "button" : "submit"}
      onClick={handleSubmit}
    >
      {buttonText}
    </Button>
  );
};

export default SubmitButton;
